"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var React = __importStar(require("react"));
var SvgCloudBackup = function (props) { return ((0, jsx_runtime_1.jsxs)("svg", __assign({ width: 24, height: 24, fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: [(0, jsx_runtime_1.jsx)("path", { d: "M2 14.5C2 16.984 4.016 19 6.5 19H18a4 4 0 0 0 .8-7.919 3 3 0 0 0-4.466-3.575A4.999 4.999 0 0 0 5 10c0 .084.003.169.006.253A4.503 4.503 0 0 0 2 14.5Z", stroke: "currentColor", strokeWidth: 1.5 }), (0, jsx_runtime_1.jsx)("path", { opacity: 0.4, fillRule: "evenodd", clipRule: "evenodd", d: "m10.015 12.96.727.08a.12.12 0 0 1 .056.217l-1.255.892a.12.12 0 0 1-.159-.017l-1.03-1.145a.12.12 0 0 1 .102-.2l.826.092a2.942 2.942 0 1 1 2.935 3.463c-.203.002-.349-.182-.326-.384.023-.202.205-.344.408-.355a2.207 2.207 0 1 0-2.284-2.643Z", fill: "currentColor", stroke: "currentColor", strokeWidth: 0.5 })] }))); };
exports.default = SvgCloudBackup;
